// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_2wWKf","title":"Card_title_3yTBX","intro":"Card_intro_1dafZ","intro2":"Card_intro2_2PHu0","btn":"Card_btn_3ULRO"};